import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { FadeUp } from "../components/Reveal";

export default function NewsArticle() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setArticle(null);
    api.get(`/news/${slug}`).then(({ data }) => setArticle(data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <main className="pt-48 pb-32 text-center">
        <h1 className="font-serif text-4xl text-ivory mb-6">Article not found</h1>
        <Link to="/news" className="text-gold text-xs uppercase tracking-[0.25em]">Back to news</Link>
      </main>
    );
  }
  if (!article) return <main className="pt-48 pb-32" />;

  return (
    <main className="pt-36 lg:pt-44 pb-24" data-testid="news-article">
      <article className="max-w-3xl mx-auto px-4 sm:px-6">
        <FadeUp>
          <Link to="/news" className="text-gold text-xs uppercase tracking-[0.25em] hover:text-gold-glow transition-colors" data-testid="article-back">
            ← All news
          </Link>
          <p className="font-mono text-xs text-gold mt-10 mb-4">
            {new Date(article.published).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
          </p>
          <h1 className="font-serif text-4xl sm:text-5xl text-ivory font-light tracking-tight leading-[1.1] mb-10">{article.title}</h1>
          {article.image && (
            <img src={article.image} alt={article.title} className="w-full aspect-[16/9] object-cover border border-white/5 mb-10" />
          )}
          <div className="space-y-5">
            {article.content.split("\n").filter(Boolean).map((para, i) => (
              <p key={i} className="text-stone-mist font-light leading-relaxed text-base">{para}</p>
            ))}
          </div>
        </FadeUp>
      </article>
    </main>
  );
}
